import { Button, styled } from "@mui/material";
import { CONSTANTS } from "../../CONSTANTS";

const StyledSecondaryButton = styled(Button)({
    background: `${CONSTANTS.COLORS.BUTTON_GREY} 0% 0% no-repeat padding-box`,
    color: CONSTANTS.COLORS.BTN_TEXT_BLUE,
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "Arial",
    textTransform: "capitalize",
    lineHeight: "20px",
    borderRadius: "24px",
    opacity: 1,
    minWidth: "122px",
})

const WrappedSecondaryButton = (props: any) => {
    return (
        <StyledSecondaryButton variant="outlined" size="medium" {...props}>
            {props.children}
        </StyledSecondaryButton>
    );
};

export default WrappedSecondaryButton;